import type { GetServerSideProps } from 'next';
import feature_raysee_4th from '../../../public/images/feature_raysee_4th.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> = async (ctx) => {
  const { commonFeatureGetServerSideProps } = await import(
    '../../server/features/commonFeatureServerSideProps'
  );
  return commonFeatureGetServerSideProps(ctx);
};

export default createFeatureNamePage({
  slug: 'raysee_4th',
  featureName: '4周年',
  title: 'RAYSEE4周年！感謝の特別メニュー一覧',
  description: 'RAYSEE4周年を記念した、今回だけの特別メニューを集めました。',
  ogImageUrl: 'https://raysee.jp/ogp.png',
  heroImage: feature_raysee_4th,
});
